import { Component, OnInit } from '@angular/core';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { CryptoService } from '../crypto.service';
import { HttpClient } from '@angular/common/http';
import { GeneralTeacherComponent } from '../../General/gt.component';

@Component({
  selector: 'app-t-define-key',
  templateUrl: './t-define-key.component.html',
  styleUrls: ['../topic-style.css','./t-define-key.component.css']
})
export class TDefineKeyComponent extends GeneralTeacherComponent  {
 
  method: string;
  keyP: any;
  plainText: string;
  cipherText: string;
  modus: string = "normal";
  text: any;

  constructor(protected topicsService: TopicService, protected activatedRoute: ActivatedRoute, public cryptoService: CryptoService, protected http: HttpClient) {
    super(topicsService, activatedRoute);
    this.type="defineKey"
    this.loadText();
    this.title = this.get("defineKey");
  }

  /** loads the text to generate words from */
  loadText(): Promise<any> {
    let textFile = "./assets/text_" + this.topicService.getLanguage() + ".txt";
    let self = this;
    return new Promise((resolve, reject) => {
      this.http
        .get<string>(textFile)
        .subscribe(response => {
          self.text = response;
          resolve(true);
        })
    })
  }

   /** sets information based on configuration */
   setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.method = this.configuration.typespecifics.method;
    if(this.method == "vignere"){
      if(this.configuration.typespecifics.text.includes("0") || this.configuration.typespecifics.text.includes("1")){
        this.method = "vignereDigits";
      } else {
        this.method = "vignereLetters";
      }
    }
    this.plainText = this.configuration.typespecifics.text;
    this.modus = this.configuration.typespecifics.modus;  
    this.cipherText = this.cryptoService.encode(this.method, this.keyP, this.plainText);
  }

  generateDefinition(): any {
    let definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id; 
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/defineKey.png";
    definition.level = (this.modus == 'highlight'?1:(this.modus=='normal'?2:3))
    definition.key = "crypto%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.method = this.method;
    if(this.method == "vignereLetters" || this.method == "vignereDigits"){
      definition.typespecifics.method = "vignere";
    }
    definition.typespecifics.text = this.plainText.trim();
    definition.typespecifics.modus = this.modus;
    definition.key = definition.key.concat("%", this.method.toString(), "%", this.plainText.slice(0,20));

   return definition;
  }

  reset() {
    super.reset();
    this.title = this.get("defineKey");
    this.method= undefined;
    this.keyP = undefined;
    this.plainText = "";
    this.cipherText = "";
    this.modus="normal";
  }

  /**
   * normalizes the text and the key and computes the cipher text
   */
  onChangeEncoding() {
    if (this.plainText) {
      if(this.method == "vignereDigits"){
        this.plainText = this.cryptoService.normalizeVignereKeys(this.plainText, 'digits');
      } else {
        this.plainText = this.cryptoService.normalizeText(this.plainText);
      }
    }
    if (this.method && (this.keyP || this.keyP == 0)) {
      switch (this.method) {
        case "caesar": {
          this.keyP = this.keyP % 26;
          if (this.keyP < 0) { this.keyP += 26; }
          break;
        }
        case "vignereLetters": {
          this.keyP = this.keyP.slice(0, 8);
          this.keyP = this.cryptoService.normalizeVignereKeys(this.keyP, 'letters'); break;
        }

        case "vignereDigits": {
          this.keyP = this.cryptoService.normalizeVignereKeys(this.keyP, 'digits');break;
        }
      }
      if (this.plainText) {
        this.cipherText = this.cryptoService.encode(this.method, this.keyP, this.plainText);
      }
    }
  }

  /** generates the exericses */
  generate(){
    let methodCode = Math.floor(Math.random() * 5);
    switch(methodCode){
      case 0: this.method = "caesar"; break;
      case 1: this.method = "monoalphabetic"; break;
      case 2: this.method = "skytale"; break;
      case 3: this.method = "vignereLetters";  break;
      case 4: this.method = "vignereDigits"; break;

    }
    this.generateText();
    if(this.method == "vignereDigits"){
      this.generate01();
    }
    this.title = this.get("defineKey");
    this.modus = "normal";
  }

  /** generates some text */
  generateText(){
    let phrases = this.text.text.split(/[.!?]/).map(v => v.trim()).filter(v => v.trim().length > 0).filter(v => v.length < 150);
    let index = Math.floor(Math.random() * phrases.length);
    this.plainText = this.cryptoService.normalizeText(phrases[index]);
    this.onChangeEncoding();
  }

  /**
   * generates a string of 0 and 1 of length 20
   */
  generate01(){
    this.plainText = "";
    for(let i = 0; i < 20; i++){
      this.plainText = this.plainText.concat(Math.random() > 0.5?"1":"0");
    }
    this.onChangeEncoding();
  }

  getMethodDescription(){
    switch(this.method){
      case "caesar": return this.get("useCaesar");
      case "polybius": return this.get("usePolybius");
      case "skytale": return this.get("useSkytale");
      case "monoalphabetic": return this.get("useMonoalphabetic");
      case "vignere": return this.get("useMask");
      case "vignereDigits": return this.get("useMask");
      case "vignereLetters": return this.get("useMask");
      case "pigpen": return this.get("usePigpen");
      case "atbash": return this.get("useAtbash");
      case "morse": return this.get("useMorse");
    }
  }
}
